module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQNMw8MqZEAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAtElEQVQ4T6XPUQ6CMBAE0OofiScy8R4ewhN4Nu6GrmXSWTpbFpxkErq0r1B0Lsu4qdTN0+u6lLn0zWENCSHrGPIIV0OoS4/YAYlwPaYR7hBkiJEI4rlbrx8ioaiMYN2wBPS838JZCNkGPhitMXOQwtSzmuH8F7JgUcs38jO/5/0rso3HuDwfAByNvR/Tr0kE8ZBH/oROIJYGnfwlJPqiQ6m/oKE01iOADmI9gnpsN7hxr5xSPqLBdkALcxyFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/woodcutting-icon.png
// module id = 508
// module chunks = 0